// import api from './fetchApi'
import chain from '@/lib/axios-chain'

// 获取左侧菜单
export const permissionMenu = () => chain.create('/user/permission/menu', 'get')

// 获取精准回传项目的auth
export const exchangeAuth = () => chain.create('/user/organize/exchangeAuth', 'get')

/**
 * 获取地区
 * code：上一级地区的code，如果需要获取顶级，参数为空。例如：获取中国所有省，传CHN。获取郑州所有区，传CHN041001
 *  */
export const getArea = () => chain.create('config/area/child', 'get')

/**
 * 地区搜索
 * fieldkey： 如company_address
 * keyword：输入内容
 */
export const SearchArea = () => chain.create('/config/area/search', 'get')

/**
 * 上报地区搜索没结果时，输入的内容
 * name：输入内容
 */
export const addAreaSearchLog = () => chain.create('/config/area/addAreaSearchLog', 'post')
/**
 * upyunUpload
 */
export const uploadSignature = () => chain.create('/upload/signature', 'post')
export const uploadFile = url => chain.create(url, 'post')

/**
 * 又拍云地址转换为站内地址，处理编辑器内容加密导致的问题
 */
export const uploadConvert = () => chain.create('/user/photo/create', 'post')

/**
 * 信息关联配置根据来源查找关联人
 * fieldkey：website 来源父级fieldkey
 * fromk：from_url 来源fieldkey
 * fromv：baidu 来源fieldvalue
 */
export const getRelateTeamInfo = () =>
  chain.create('/config/getrelateuserbyrelatecon', 'post')

/**
 * 根据询盘内容获取关联的跟进人员
 */
export const getAssignTeamInfo = () =>
  chain.create('/config/getAssignInfoByInquiryInfo', 'POST')
/**
 * 有信息跟进权限的人员，在录入信息界面，选择的信息类型是「备案」时，跟进人员列表
 */
export const getFollowUsers = () =>
  chain.create('/inquiry/inquiry/getfollowusers', 'get')

/**
 * 获取各个团队的团队组人
 * teamtype: 开发团队3|接待团队4|销售团队5
 * type: 0团队组人|1团队组|2团队
 *  */
export const getTeamInfo = () =>
  chain.create('/user/team/getroleusersinfo', 'get')

/**
 * 获取具有对应权限的团队组人
 * pk: 接待inquiry-add|开发inquiry-dev|跟进inquiry-followup|审核inquiry-audit
 * type：0团队组人 | 1团队组 | 2团队
 * deal：是否过滤掉空的团队和组 0不过滤 1过滤
 */
export const getAuthTeamInfo = () =>
  chain.create('/user/team/getauthusersinfobypk', 'get')

/**
 * 获取具有对应权限的团队组人跟自己权限相关(获取相关人员 , 信息关联配置)
 * pk: 接待inquiry-add|开发inquiry-dev|跟进inquiry-followup|审核inquiry-audit
 * type：0团队组人 | 1团队组 | 2团队
 * deal：是否过滤掉空的团队和组 0不过滤 1过滤
 * isshowlevel：是否展示等级
 * isshowall: 是否展示全部俩字
 */
export const getMyAuthTeamInfo = () =>
  chain.create('/user/team/getauthusersinfobypkandauth', 'get')

/**
 * 获取自己加入的具有对应权限的团队组人
 * pk: 接待inquiry-add|开发inquiry-dev|跟进inquiry-followup|审核inquiry-audit
 */
export const getJoinTeamInfo = () =>
  chain.create('/user/team/getmyjoinroleusersinfo', 'get')

/**
 * 获取离职交接，具有对应权限的人员列表
 * pk: 接待inquiry-add|开发inquiry-dev|跟进inquiry-followup|审核inquiry-audit
 */
export const getResignTeamInfo = () =>
  chain.create('/user/team/getauthuserslistbypk', 'get')

/**
 * 团队管理_小组下的人员列表（小组详情）
 * groupid
 * type
 */
export const getTeamGroupDetail = () =>
  chain.create('/user/team/groupdetail', 'get')

// 获取头部通知信息数据
export const fetchNoticeDatas = () =>
  chain.create('/user/notice/unreadindex', 'get')

// 获取头部通知信息数据
export const delNoticeDatas = () =>
  chain.create('/user/notice/batchsetread', 'post')

export const projectDetail = () => chain.create('/album/detail', 'get')
export const accountLogin = () => chain.create('/user/login/index', 'post')
export const accountRegister = () => chain.create('/user/reg/index', 'post')
export const accountRegister2 = () => chain.create('/user/reg/supply', 'post')
export const accountProfile = () => chain.create('/user/user/userinfo')
export const validCode = () => chain.create('/user/common/sendcode', 'post')
export const geetestInit = () => chain.create('/user/common/geetest', 'get')

export const mixLogin = () => chain.create('/client/login', 'post')
export const mixGetkey = () => chain.create('/client/key', 'get')

// 离职人员团队/小组
export const getQueitTeam = () =>
  chain.create('/user/team/getmyjoinroleusersinfo', 'get')

// 用户名和昵称验证
export const validName = () => chain.create('/user/user/submitverify', 'post')

// 角色更换提示关闭操作
export const closeRoleTip = () =>
  chain.create('/user/team/setUserRoleLog', 'post')
// 获取socket的token
export const getSocketToken = () => chain.create('/user/common/wstoken', 'get')

// 钉钉判断是否跳转 项目
export const getDingding = () => chain.create('/user/organize/isredirect', 'get')

// 获取新功能通告
export const getNewFeatureInfo = () => chain.create('/user/organize/getValidAnn', 'get')

// 设置新功能通告已读
export const setNewFeatureRead = () => chain.create('/user/organize/readAnn', 'get')

// 关闭横幅广告
export const closeNewAnnounce = () => chain.create('/user/organize/readAnn', 'post')

// 最近30天的有效站内信
export const getStationMessage = () => chain.create('/user/organize/getStationMessage', 'get')

// 站内信已读读
export const readStationMessage = () => chain.create('/user/organize/readStationMessage', 'post')
